import { MenuProps } from 'antd'
import KDropdown from 'app/components/UI-Elements/Navigation/KDropdown'
import { RecordType } from 'app/constants/GlobalTypes'
import useTranslation, { buttonTitlePrefix } from 'app/lib/hooks/useTranslation'
import { Routes } from 'app/routes/Routes'
import * as React from 'react'
import { useNavigate } from 'react-router-dom'

import { MemberProps } from '../convention'

const optionsKeys = [RecordType.rental, RecordType.project]
const links: Record<string, (member: IInvoice) => string> = {
  [RecordType.rental]: (member: IInvoice) => Routes.Rental.member(`${member.rental_id}`).show,
  [RecordType.project]: (member: IInvoice) => Routes.Project.member(`${member.project_id}`).invoice
}

const TableAction: React.FC<MemberProps<IInvoice>> = ({ member }) => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  const onMenuClick: MenuProps['onClick'] = (e) => {
    e.domEvent?.stopPropagation?.()
    const getLink = links[e.key]
    navigate(getLink?.(member))
  }

  const onDropdownClick = (e: React.MouseEvent<HTMLElement, MouseEvent>): void => {
    e.stopPropagation()
    console.log(member)
  }
  const options = optionsKeys.map((key) => ({
    key,
    label: t({ id: `${buttonTitlePrefix}.${key}.link` })
  }))

  return (
    <KDropdown
      onMenuClick={onMenuClick}
      options={options}
      buttonProps={{
        onClick: onDropdownClick,
        title: t({
          id: `${buttonTitlePrefix}.invoice.actions`
        }),
        size: 'small'
      }}
    />
  )
}

export default TableAction
